import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson, notify } from "../../../utils/http";

export default function EditarContrato({ initial, onClose, onSaved, embedded = false }) {
  const [codigo, setCodigo] = useState(initial?.codigo || "");
  const [descricaoTexto, setDescricaoTexto] = useState(initial?.descricaoTexto || "");
  const [data, setData] = useState(initial?.data || "");
  const [dataFechaini, setDataFechaini] = useState(initial?.dataFechaini || "");
  const [dataFechafin, setDataFechafin] = useState(initial?.dataFechafin || "");

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const isValid = codigo.trim() !== "";

  // Cerrar con ESC solo si no está embebido
  useEffect(() => {
    if (embedded) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose, embedded]);

  const handleSave = async () => {
    if (!isValid || saving) return;

    if (dataFechaini && dataFechafin && dataFechafin < dataFechaini) {
      setError("La fecha fin no puede ser anterior a la fecha inicio");
      return;
    }

    setError("");
    setSaving(true);

    try {
      const payload = {
        codigo: codigo.trim(),
        descricaoTexto: descricaoTexto.trim() || null,
        data: data || null,
        dataFechaini: dataFechaini || null,
        dataFechafin: dataFechafin || null,
      };

      const url = apiRoutes.contratos.editarUrl(initial.id);
      const updated = await appFetchJson(url, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      notify({ type: "success", message: "Contrato actualizado correctamente" });
      onSaved(updated);
      if (!embedded) onClose();
    } catch (e) {
      console.error("Error editando contrato:", e);
      setError(e?.message || "Error al actualizar el contrato.");
      notify({ type: "error", message: e?.message || "Error al actualizar el contrato." });
    } finally {
      setSaving(false);
    }
  };

  const content = (
    <>
      {!embedded && (
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Editar Contrato</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
      )}

      <div className={embedded ? "" : "modal-body"}>
        {!embedded && (
          <p className="text-gray-600 mb-4 italic">
            Modifique los datos del contrato.
          </p>
        )}

        {error && <div className="text-red-600 mb-3 font-medium">{error}</div>}

        <div className="form-grid">
          <div className="form-row col-span-2">
            <label className="form-label">Código del Contrato *</label>
            <input
              type="text"
              className="input w-full"
              value={codigo}
              onChange={(e) => setCodigo(e.target.value)}
              placeholder="Ej: S840016501-CHORTI"
            />
          </div>

          <div className="form-row col-span-2">
            <label className="form-label">Descripción</label>
            <textarea
              rows="3"
              className="input w-full"
              value={descricaoTexto}
              onChange={(e) => setDescricaoTexto(e.target.value)}
              placeholder="Texto descriptivo del contrato..."
            />
          </div>

          <div className="form-row col-span-2">
            <label className="form-label">Fecha del Contrato</label>
            <input
              type="date"
              className="input w-full"
              value={data}
              onChange={(e) => setData(e.target.value)}
            />
          </div>

          <div className="form-row col-span-2">
            <label className="form-label">Fecha Inicio</label>
            <input
              type="date"
              className="input w-full"
              value={dataFechaini}
              onChange={(e) => setDataFechaini(e.target.value)}
            />
          </div>

          <div className="form-row col-span-2">
            <label className="form-label">Fecha Fin</label>
            <input
              type="date"
              className="input w-full"
              value={dataFechafin}
              onChange={(e) => setDataFechafin(e.target.value)}
            />
            {dataFechaini && dataFechafin && dataFechafin < dataFechaini && (
              <div className="text-red-500 text-sm mt-1">
                La fecha fin no puede ser anterior a la fecha inicio
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={embedded ? "mt-6 border-b pb-6" : "modal-footer"}>
        <div className="btn-row">
          <BtnGuardar
            label={saving ? "Guardando..." : "Guardar Cambios"}
            isValid={isValid && (!dataFechaini || !dataFechafin || dataFechafin >= dataFechaini)}
            saving={saving}
            onClick={handleSave}
          />
          {!embedded && <BtnCancelar onClick={onClose} />}
        </div>
      </div>
    </>
  );

  if (embedded) {
    return <div className="bg-white p-1">{content}</div>;
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={(e) => e.stopPropagation()}>
        {content}
      </div>
    </div>
  );
}